const isEmpty = value => {
  if (!value) return true;
  if (Array.isArray(value) && !value.length) return true;
  return (
    typeof value === 'object' &&
    value.constructor === Object &&
    Object.keys(value).length === 0
  );
};

export default isEmpty;
